import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import logo from "assets/logo/logo.png";

// Top of the login and sign-up pages, which have no navbar: a way back to the
// site, and the logo, which links home as it does everywhere else.
const AuthHeader = () => (
  <div className="w-full max-w-md flex flex-col items-center">
    <Link
      to="/"
      className="self-start inline-flex items-center gap-2 mb-4 text-sm text-slate-400 hover:text-slate-200 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 rounded"
    >
      <ArrowLeft size={18} aria-hidden="true" />
      Retour à l'accueil
    </Link>

    <Link
      to="/"
      aria-label="FQST, page d'accueil"
      className="mb-4 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
    >
      <motion.img
        src={logo}
        alt=""
        className="w-64"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      />
    </Link>
  </div>
);

export default AuthHeader;
